export default __webpack_public_path__ + "static/media/flutter.a87a000d.svg";